import { baseApi } from '../baseApi';
import { PersonModel } from '../../models/personModel';
import { PersonRole } from '../../models/eums/personRole';
import { cleanObject } from '../../utils/objectUtils';

export async function listPersonsReq(role?: PersonRole) {
  let url = '/officiating/person/list?';
  let queryParamsObj = cleanObject({
    role,
  });

  const queryParams = new URLSearchParams(queryParamsObj);
  return baseApi.get<PersonModel[]>(url + queryParams);
}
